import { useMemo } from 'react';
import useStore from '~/store';
import { ARIDE_PARK_PRODUCT_ID, TRACKING_PRODUCT_ID } from '~/utils/promotionUtils';

const GUARANTEE_PRODUCT_ID = '9';

/**
 * Valores derivados para o resumo e botão (evita recálculo e funções inline no render).
 */
export function usePersonalCoverageSummary(
  checkedTermOfContract: boolean,
  checkedTermOfGarantee: boolean,
  checkedTermOfTracking: boolean
) {
  const products = useStore((s) => s.products);
  const has_promotion = useStore((s) => s.promotionData?.has_promotion);
  const promotionalMonths = useStore((s) => s.quoteResponse?.promotional_months);

  const isOnlyProduct9 = useMemo(
    () => products.length === 1 && products[0]?.product_id === GUARANTEE_PRODUCT_ID,
    [products]
  );

  const isGuaranteeSelected = useMemo(
    () => Boolean(products.find((p) => p.product_id === GUARANTEE_PRODUCT_ID)),
    [products]
  );

  const isTrackingSelected = useMemo(
    () => Boolean(products.find((p) => p.product_id === TRACKING_PRODUCT_ID.toString())),
    [products]
  );

  const isProductFree = useMemo(
    () => (productId: string | number) => {
      const id = typeof productId === 'string' ? parseInt(productId, 10) : productId;
      if (id === ARIDE_PARK_PRODUCT_ID) return true;
      if (has_promotion && promotionalMonths && promotionalMonths > 0) return true;
      return false;
    },
    [has_promotion, promotionalMonths]
  );

  // A garantia (id 9) exige o termo de contrato (General) e o termo de garantia (Warranty).
  // O rastreamento (id 10) exige seu próprio termo (TrackingService), de forma independente.
  const shouldDisableSubmit = useMemo(
    () =>
      products.length === 0 ||
      (isGuaranteeSelected && (!checkedTermOfContract || !checkedTermOfGarantee)) ||
      (isTrackingSelected && !checkedTermOfTracking),
    [
      products.length,
      isGuaranteeSelected,
      isTrackingSelected,
      checkedTermOfContract,
      checkedTermOfGarantee,
      checkedTermOfTracking
    ]
  );

  return { isOnlyProduct9, isGuaranteeSelected, isTrackingSelected, isProductFree, shouldDisableSubmit };
}
